import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Message, Table } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import { PagingParams } from "../../app/models/pagination";
import MyPaging from "../../app/common/form/MyPaging";
import { InventoryStockPartDetailsCoresDto } from "../../app/models/inventory";

type Props = {
  id: string;
};
export default observer(function PartDetailsTickets({ id }: Props) {
  const { t } = useTranslation(["common", "customer", "inventory"]);

  const { inventoryPartDetailsStore } = useStore();

  const {
    partDetailsCoresPagination,
    partDetailsCoresPagingParams,
    setPartDetailsCoresPagingParams,
    resetPartDetailsCoresRegistry,
    loadInventoryPartCores,
    getSelectedPartDetailsCores
  } = inventoryPartDetailsStore;

  function listOnClick(value: number) {
    if (
      value > 0 &&
      partDetailsCoresPagination &&
      value < partDetailsCoresPagination?.totalPages + 1
    ) {
      setPartDetailsCoresPagingParams(new PagingParams(value));
      resetPartDetailsCoresRegistry();
      loadInventoryPartCores(id);
    }
  }
  return (
    <Table striped unstackable className="dnxTable">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign="left" width={1}>
            {t("labels.coreTrackingQuantity", { ns: "inventory" })}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            {`${t("returned", { ns: "inventory" })}`}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {`${t("refunded", { ns: "inventory" })}`}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {getSelectedPartDetailsCores && getSelectedPartDetailsCores.length
          ? getSelectedPartDetailsCores.map((core: InventoryStockPartDetailsCoresDto) => (
            <Table.Row key={core.id}>
              <Table.Cell
                textAlign="left"
                data-label={`${t("labels.coreTrackingQuantity", { ns: "inventory" })}:`}
                width={1}
              >
                {core.quantity ?? 0}
              </Table.Cell>
              <Table.Cell
                textAlign="center"
                data-label={`${t("returned", { ns: "inventory" })}:`}
                width={2}
              >
                {core.returnedQuantity}
              </Table.Cell>
              <Table.Cell
                textAlign="right"
                data-label={`${t("refunded", { ns: "inventory" })}:`}
                width={2}
              >
                {core.refundedQuantity}
              </Table.Cell>
            </Table.Row>
          )) : (
            <Table.Row key={"noItems"}>
              <Table.Cell width="3" colSpan={3}>
                <Message
                  color="yellow"
                  className="textAlignCenter fontStyleItalic"
                >
                  {t("grid_noItems", { ns: "common" })}
                </Message>
              </Table.Cell>
            </Table.Row>
          )}
      </Table.Body>
      <Table.Footer>
        <Table.Row>
          <Table.Cell colSpan="3">
            <MyPaging
              itemCount={
                partDetailsCoresPagination
                  ? partDetailsCoresPagination.totalItems
                  : 10
              }
              pageSize={partDetailsCoresPagingParams.pageSize}
              currentPage={
                partDetailsCoresPagination
                  ? partDetailsCoresPagination.currentPage
                  : 1
              }
              onClick={listOnClick}
              onChange={listOnClick}
              floated="right"
            ></MyPaging>
          </Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
});
